import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Col, Form, FormFeedback, FormGroup, Input, Label, Row} from "reactstrap"
import {REASON} from "../../helpers/filterLists"
import {SHIPPING_LEVELS, CARRIERS_SUPPORT_SHIPPING_LEVELS} from "../../../../configs/config"
import convertNumberRound from "../../../helpers/convertNumberRound"
import { getListShippingCarrierApp } from '../../../../services/api/apiFFM'
import { message } from 'antd'

class FormOrderNumber extends Component {
    state = {
        listShippingCarrier: [],
    }
    _handleChangeOrderNumber = (e) => {
        const {value} = e.target
        const {onGetDataOrder} = this.props

        if (typeof onGetDataOrder === 'function') {
            onGetDataOrder(value)
        }
    }

    _handleChange = (e) => {
        const {name, value} = e.target
        const {onChangeData} = this.props

        if (typeof onChangeData === 'function') {
            onChangeData(name, value)
        }
    }

    fetchShippingCarrier = async () => {
        try {
            const payload = {
                limit: 10000,
                page: 1,
            }
            const { data, success, message: mess } = await getListShippingCarrierApp(payload)
            if (!success) {
                throw new Error(mess)
            }
            const shippingCarriers = !!data.shippingCarriers && data.shippingCarriers.length > 0 ? data.shippingCarriers.sort((a, b) => {
                const nameA = a.name.toUpperCase()
                const nameB = b.name.toUpperCase()
                if (nameA < nameB) { return -1 }
                if (nameA > nameB) { return 1 }
                return 0
            }) : []
            this.setState({ listShippingCarrier: shippingCarriers || [] })
        } catch (error) {
            message.error(error.message)
        }
    }
    
    componentDidMount() {
        this.fetchShippingCarrier()
    }

    render() {
        const {
            string,
            label,
            weight,
            volume,
            reason,
            netWeight,
            netVolume,
            description,
            errorGetData,
            loadingGetData,
            shipping_carrier,
            shipping_level
        } = this.props

        const { listShippingCarrier } = this.state

        return (
            <Form>
                <Row form>
                    <Col md={6}>
                        <FormGroup row>
                            <Label for="string" className='' md={4}>Barcode Number</Label>
                            <Col md={8}>
                                <Input type="text" name="string" id="string" value={string || ''}
                                       disabled={loadingGetData}
                                       autoFocus={true}
                                       placeholder={'Nhập/quét vào mã barcode'}
                                       invalid={!!errorGetData} onChange={this._handleChangeOrderNumber}
                                />
                                <FormFeedback tooltip>
                                    {!!errorGetData && errorGetData}
                                </FormFeedback>
                            </Col>
                        </FormGroup>
                    </Col>
                    <Col md={6}>
                        <FormGroup row>
                            <Label for="label" className='text-right' md={4}>Label</Label>
                            <Col md={8}>
                                <Input type="text" name="label" id="label" disabled value={label || ''}
                                       onChange={this._handleChange}/>
                            </Col>
                        </FormGroup>
                    </Col>
                </Row>
                <Row form>
                    <Col md={6}>
                        <FormGroup row>
                            <Label for="weight" className='' md={4}>Cân nặng setting</Label>
                            <Col md={8}>
                                <Input type="number" name="weight" id="weight" disabled
                                       value={convertNumberRound(weight, 2)}
                                       onChange={this._handleChange}/>
                            </Col>
                        </FormGroup>
                    </Col>
                    <Col md={6}>
                        <FormGroup row>
                            <Label for="volume" className='text-right' md={4}>Cân nặng thể tích</Label>
                            <Col md={8}>
                                <Input type="number" name="volume" id="volume" disabled
                                       value={convertNumberRound(volume, 2)}
                                       onChange={this._handleChange}/>
                            </Col>
                        </FormGroup>
                    </Col>
                </Row>
                <Row form>
                    <Col md={12}>
                        <FormGroup row>
                            <Label for="reason" className='' md={2}>Lý do</Label>
                            <Col md={10}>
                                <Input type="select" name="reason" id="reason" value={reason}
                                       disabled={!weight}
                                       onChange={this._handleChange}>
                                    {
                                        REASON.map((option, index) => {
                                            const {name, value} = option
                                            return (value !== '' &&
                                                <option key={`${value}_${index + 1}`}
                                                        value={value}>{name}</option>)
                                        })
                                    }
                                </Input>
                            </Col>
                        </FormGroup>
                    </Col>
                </Row>

                {
                    reason === 'change_shipping_carrier' && <>
                        <Row form>
                            <Col md={12}>
                                <FormGroup row>
                                    <Label for="shipping_carrier" md={2}>Shipping carrier</Label>
                                    <Col md={10}>
                                        <Input
                                            type="select"
                                            name="shipping_carrier"
                                            id="shipping_carrier"
                                            value={shipping_carrier}
                                            disabled={!weight}
                                            onChange={this._handleChange}
                                        >
                                            <option value={''}>Default</option>
                                            {!!listShippingCarrier && listShippingCarrier.length > 0 &&
                                                listShippingCarrier.map((i, index) => (
                                                    <option key={index} style={!i.is_active ? {color: '#777'} : { color: '#333' }} value={i.slug}>{i.name}</option>
                                                ))
                                            }
                                        </Input>
                                    </Col>
                                </FormGroup>
                            </Col>
                        </Row>
                        {
                            CARRIERS_SUPPORT_SHIPPING_LEVELS.includes(shipping_carrier) &&
                            <Row form>
                                <Col md={12}>
                                    <FormGroup row>
                                        <Label for="shipping_carrier" md={2}>Shipping level</Label>
                                        <Col md={10}>
                                            <Input
                                                type="select"
                                                name="shipping_level"
                                                id="shipping_level"
                                                value={shipping_level}
                                                disabled={!CARRIERS_SUPPORT_SHIPPING_LEVELS.includes(shipping_carrier)}
                                                onChange={this._handleChange}
                                            >
                                                <option value="">Select shipping level</option>

                                                {
                                                    SHIPPING_LEVELS.map(item =>
                                                        <option key={item.value} value={item.value}>{item.name}</option>
                                                    )
                                                }
                                            </Input>
                                        </Col>
                                    </FormGroup>
                                </Col>
                            </Row>
                        }
                    </>
                }

                {
                    (reason === 'other' || reason === 'change_shipping_carrier') &&
                    <div className='ReasonOther'>
                        <Row form>
                            <Col md={6}>
                                <FormGroup row>
                                    <Label for="netWeight" className='' md={4}>Cân nặng thực tế</Label>
                                    <Col md={8}>
                                        <Input type="number" name="netWeight" id="netWeight" value={netWeight}
                                               disabled={!weight} onChange={this._handleChange}/>
                                    </Col>
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup row>
                                    <Label for="netVolume" className=' text-right' md={4}>Thể tích thực tế</Label>
                                    <Col md={8}>
                                        <Input type="number" name="netVolume" id="netVolume" value={netVolume}
                                               disabled={!weight} onChange={this._handleChange}/>
                                    </Col>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row form>
                            <Col md={12}>
                                <FormGroup row>
                                    <Label for="description" md={2}>Nội dung</Label>
                                    <Col md={10}>
                                        <Input type="textarea" name="description" id="description"
                                               value={description}
                                               placeholder={'Nhập nội dung yêu cầu'}
                                               disabled={!weight} onChange={this._handleChange}/>
                                    </Col>
                                </FormGroup>
                            </Col>
                        </Row>
                    </div>
                }
            </Form>
        )
    }
}

FormOrderNumber.propTypes = {
    loadingGetData: PropTypes.bool,
    errorGetData: PropTypes.string,
    label: PropTypes.string,
    weight: PropTypes.number,
    volume: PropTypes.number,
    reason: PropTypes.string,
    realityWeight: PropTypes.number,
    realityVolume: PropTypes.number,
    description: PropTypes.string,
    onChangeData: PropTypes.func.isRequired,
    onGetDataOrder: PropTypes.func.isRequired
}

export default FormOrderNumber